// extracted by mini-css-extract-plugin
export var arrowWrap = "PhotoCard-module--arrowWrap--nvp-f";
export var card = "PhotoCard-module--card--f-p+l";
export var info = "PhotoCard-module--info--1eE93";
export var nameRow = "PhotoCard-module--nameRow--rDm2H";
export var page404Title = "PhotoCard-module--page404-title--GM4-g";